<template>
  <div>
    <CContainer>
      <CRow>
        <CCol md="12">
          <CCard>
            <CCardBody>
              <h3 class="mb-3">Terms and Condition</h3>
              <vue-editor 
                v-model="tncText" 
                :editor-toolbar="customToolbar"
                :disabled="!isEdit" />
              <h5 class="mt-4 mb-3">Chinese Version</h5>
              <vue-editor 
                v-model="chineseTncText" 
                :editor-toolbar="customToolbar"
                :disabled="!isEdit" />
            </CCardBody>
            <CCardFooter>
              <div v-if="!isEdit">
                <CButton class="mr-2" color="primary" @click="() => { isEdit = !isEdit }">
                  <div class="button-text">
                    <CIcon name="cil-pencil" />
                    <span>Edit</span>
                  </div>
                </CButton>
              </div>
              <div v-else>
                <CButton class="mr-2" color="primary" @click="handleSave">
                  <div class="button-text">
                    <CIcon name="cil-check-circle" />
                    <span>Save</span>
                  </div>
                </CButton>
                <CButton color="danger" @click="() => { 
                  isEdit = !isEdit 
                  tncText = initialTncText
                  chineseTncText = initialChineseTncText
                }">
                  <div class="button-text">
                    <CIcon name="cil-ban" />
                    <span>Cancel</span>
                  </div>
                </CButton>
              </div>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import {
  CONFIG_GET,
  CONFIG_UPDATE,
} from '../../../constants/api'

import axios from 'axios'

import { VueEditor } from 'vue2-editor'

export default {
  components: { VueEditor },

  data () {
    return {
      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ 'align': [] }],
        ['clean']  
      ],
      tncText: '',
      chineseTncText: '',
      initialTncText: '',
      initialChineseTncText: '',
      isEdit: false,
      accessToken: sessionStorage.getItem('access_token') || '',
    }
  },

  beforeMount () {
    this.fetchConfig()
  },

  methods: {
    fetchConfig () {
      axios.get(`${CONFIG_GET}/tnc`, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(res => {
          const { content, chinese_content } = res.data.data
          this.tncText = content
          this.initialTncText = content
          this.chineseTncText = chinese_content
          this.initialChineseTncText = chinese_content
        })
    },

    handleSave () {
      const payload = {
        newConfig: JSON.stringify({ content: this.tncText, chinese_content: this.chineseTncText })
      }
      axios.put(`${CONFIG_UPDATE}/tnc`, payload, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(() => {
          this.fetchConfig()
          this.isEdit = !this.isEdit
        })
    }
  }
}
</script>

<style scoped>
  .button-text {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .button-text > span {
    margin-left: 6px;
  }
</style>